import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Navigation from './Navigation';
import Home from './Home';

const WelcomeDiv = styled.div`
width: 100%;
height: 100vh;
position: relative;
`;


const FadeOut = styled.div.attrs(props => ({
    className: props.className,
}))`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    visibility: hidden;
    opacity: 0;
    background-color: var(--color-bg-shades);

    &.active {
        z-index: 1000;
        visibility: visible;
        opacity: 1;
        animation:  fadeOut .3s ease-out;
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0
        }
    }
`;

const Welcome = ({ onInputFocus }) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const [fadeEffect, setFadeEffect] = useState(false);

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    }

    const HandleMenuHide = () => {
        setMenuOpen(false);

        handleFadeEffect();
    }

    const handleFadeEffect = () => {
        setFadeEffect(true);

        setTimeout(() => {
            setFadeEffect(false);
        },300)
    }

    const handleSelectMenu = (e) => {
        const targetNames = ['home', 'about', 'projects', 'contact'];
        if (targetNames.includes(e.target.name)) HandleMenuHide();
    }

    return (
        <Fragment>
            <WelcomeDiv>
                <FadeOut className={fadeEffect ? 'active' : ''}></FadeOut>
                <Header onToggleMenu={handleMenuToggle}/>
                <Navigation 
                    menuOpen={menuOpen}
                    onHideMenu={HandleMenuHide}
                    onSelect={handleSelectMenu}
                    onInputFocus={onInputFocus}
                />
                <Home/>
            </WelcomeDiv>
        </Fragment>
    )
}

export default Welcome
